/**
 * SHER-441 — Coverage is per medical act; legacy coverage names often embed
 * a percentage (e.g. "PAF (80%)" or "Mutuelle 75%") that misleads users.
 */
export function formatCoverageDisplayName(name: string | null | undefined): string {
    if (!name) {
        return '';
    }

    let label = name.trim();
    label = label.replace(/\s*\(\s*\d+(?:\.\d+)?\s*%\s*\)\s*$/i, '');
    label = label.replace(/\s+\d+(?:\.\d+)?\s*%\s*$/i, '');
    return label.trim();
}

/**
 * SHER-441 — the display name of an already-chosen coverage.
 *
 * A coverage's name embeds the percentage its `percentage` column already holds
 * ("Assemblée nationale 80%"), and one insurer exists once per band — 20 rows in
 * CHOM. Where a *single* coverage is being displayed, the insurer name is the
 * honest label: coverage is applied per medical act, so a global percentage
 * reads as a promise the system does not make.
 *
 * Reading `insurance.name` rather than stripping the suffix is deliberate. The
 * two agree on all 4.320 production rows, but one is the stored name and the
 * other is a guess reconstructed by regex — the stripping stays only as the
 * fallback for the ~200 legacy coverages that carry no insurance link.
 *
 * NOT for the coverage *selector*. There the percentage is the only thing that
 * tells 20 otherwise identical options apart; see FieldSherwood's
 * searchable_select and ChangeCoverageModal, which show the full name.
 */
export function resolveCoverageDisplayName(
    coverage: { name?: string | null; insuranceId?: number | null } | null | undefined,
    insurances?: Array<{ id: number; name?: string | null }> | null,
): string {
    if (!coverage) {
        return '';
    }

    const insurance = coverage.insuranceId != null
        ? (insurances || []).find((ins) => ins && ins.id === coverage.insuranceId)
        : undefined;

    const insuranceName = insurance?.name?.trim();
    return insuranceName || formatCoverageDisplayName(coverage.name);
}
